module.exports = __webpack_public_path__ + "img/full2-min.a7e4fb9e.png";